import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaHardHat,
  FaShieldAlt,
  FaTruck,
  FaClock,
  FaAward,
  FaArrowRight,
} from "react-icons/fa";

import shellconstruction from "../assets/images/shellconstruct.jpg";
import shell from "../assets/images/shell.png";
import industrial from "../assets/images/industrial.png";
import management from "../assets/images/banner2.0.png";
import renovation from "../assets/images/renovation.jpg";
import concrete from "../assets/images/concretestructure2.jpg";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function Services() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const services = [
    {
      icon: <FaBuilding className="service-icon" />,
      title: t("services.shell.title"),
      description: t("services.shell.description"),
      features: t("services.shell.features", { returnObjects: true }),
      image: shellconstruction,
    },
    {
      icon: <FaHardHat className="service-icon" />,
      title: t("services.foundation.title"),
      description: t("services.foundation.description"),
      features: t("services.foundation.features", { returnObjects: true }),
      image: shell,
    },
    {
      icon: <FaShieldAlt className="service-icon" />,
      title: t("services.concrete.title"),
      description: t("services.concrete.description"),
      features: t("services.concrete.features", { returnObjects: true }),
      image: concrete,
    },
    {
      icon: <FaTruck className="service-icon" />,
      title: t("services.industrial.title"),
      description: t("services.industrial.description"),
      features: t("services.industrial.features", { returnObjects: true }),
      image: industrial,
    },
    {
      icon: <FaClock className="service-icon" />,
      title: t("services.renovation.title"),
      description: t("services.renovation.description"),
      features: t("services.renovation.features", { returnObjects: true }),
      image: renovation,
    },
    {
      icon: <FaAward className="service-icon" />,
      title: t("services.projectmanagement.title"),
      description: t("services.projectmanagement.description"),
      features: t("services.projectmanagement.features", {
        returnObjects: true,
      }),
      image: management,
    },
  ];
  return (
    <>
      <Helmet>
        <title>{t("seo.services.title")}</title>
        <meta name="description" content={t("seo.services.description")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${window.location.origin}/${currentLang}/services`} />

        <meta property="og:title" content={t("seo.services.title")} />
        <meta property="og:description" content={t("seo.services.description")} />
        <meta property="og:url" content={`${window.location.origin}/${currentLang}/services`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("seo.services.title")} />
        <meta name="twitter:description" content={t("seo.services.description")} />
        <meta name="twitter:image" content="path/to/your/image.jpg" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white page-header">
        <Container>
          <div style={{ maxWidth: "800px" }}>
            <h1 className="display-4 fw-bold mb-4">
              {t("services.hero.title")}{" "}
            </h1>
            <p className="fs-4 text-white-80">
              {t("services.hero.description")}{" "}
            </p>
          </div>
        </Container>
      </section>

      {/* Services List */}
      <section className="section-padding bg-light">
        <Container>
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <Row
                className={`align-items-center ${
                  index % 2 === 1 ? "flex-row-reverse" : ""
                }`}
              >
                <Col lg={6} className="mb-4 mb-lg-0">
                  <div className="d-flex align-items-center mb-4">
                    <div className="me-3">{service.icon}</div>
                    <h2 className="mb-0">{service.title}</h2>
                  </div>

                  <p className="text-secondary mb-4">{service.description}</p>

                  <ul className="list-unstyled mb-4">
                    {service.features.map((feature, i) => (
                      <li key={i} className="feature-item">
                        <FaArrowRight className="feature-icon" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* <Button
                    as={Link}
                    to={`/services/${service.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                    variant="tertiary"
                  >
                    Learn More
                  </Button> */}
                </Col>

                <Col lg={6}>
                  <div
                    className="service-image"
                    style={{ height: "400px", position: "relative" }}
                  >
                    <img
                      src={service.image || "/placeholder.svg"}
                      alt={service.title}
                      className="img-cover"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      loading="lazy"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section section-padding">
        <Container>
          <div className="cta-content">
            <h2>{t("home.cta.title")} </h2>
            <p>{t("home.cta.description")} </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Button
                variant="tertiary"
                size="lg"
                as={Link}
                to={`/${currentLang}/contact`}
              >
                {t("home.cta.buttonQuote")}{" "}
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Services;
